import { MEETING_CONNECTIONS_AUTO_SUBSCRIPTION_TEXT, MEETING_CONNECTIONS_AUTOREG_TEXT, PODIUM_LINK_ENABLED_TEXT } from '../../../_events/_manage-event/_connections/connections.texts';

export const BLUEPRINTS_CONNECTION_FORM_EDIT_TITLE_TEXT = {
    id: 'oe.blueprints.connection.edit.title',
    defaultMessage: 'Edit Connection Details',
    description: 'Popover header text'
};

export const BLUEPRINTS_CONNECTION_FORM_CREATE_TITLE_TEXT = {
    id: 'oe.blueprints.connection.create.title',
    defaultMessage: 'New Connection',
    description: 'Popover header text'
};

export const FORM_ARE_YOU_SURE_TO_TEXT = {
    id: 'oe.confirm.areYouSureTo',
    description: 'Confirm message',
    defaultMessage: 'Are you sure you want to',
};

export const DELETE_CONNECTION_TEMPLATE_TEXT = {
    id: 'oe.blueprints.deleteConnectionTemplate',
    description: 'Confirm message',
    defaultMessage: 'Delete this Connection Template?',
};

export const THIS_CANNOT_BE_UNDONE_TEXT = {
    id: 'oe.blueprints.thisCannotBeUndone',
    description: 'Alert message',
    defaultMessage: 'This cannot be undone.',
};

export const YES_DELETE_TEXT = {
    description: 'Label text',
    defaultMessage: 'Yes, Delete',
    id: 'oe.blueprint.YesDelete',
};

export const ROLE_CONNECTIONS_SECTION_TEXT = {
    id: 'oe.templates.connection.roleConnections',
    defaultMessage: 'Role Connections',
    description: 'Section title',
};

export const ROLE_CONNECTION_PRESENTER_TEXT = {
    id: 'oe.templates.connection.roleConnections.presenter',
    defaultMessage: 'Presenter',
    description: 'Role connection label',
};

export const ROLE_CONNECTION_HOST_TEXT = {
    id: 'oe.templates.connection.roleConnections.host',
    defaultMessage: 'Host',
    description: 'Role connection label',
};

export const ROLE_CONNECTION_SUPPORT_TEXT = {
    id: 'oe.templates.connection.roleConnections.support',
    defaultMessage: 'Support',
    description: 'Role connection label',
};

export const BLUEPRINT_DELETE_TEMPLATE_TEXT = {
    id: 'oe.blueprint.deleteTemplate',
    defaultMessage: 'Delete Template',
    description: 'Label text'
};

export const AUTO_REGISTRATION_ENABLED_TEXT = {
    ...MEETING_CONNECTIONS_AUTOREG_TEXT,
    message: MEETING_CONNECTIONS_AUTOREG_TEXT.defaultMessage
};

export const AUTO_SUBSCRIPTION_ENABLED_TEXT = {
    ...MEETING_CONNECTIONS_AUTO_SUBSCRIPTION_TEXT,
    message: MEETING_CONNECTIONS_AUTO_SUBSCRIPTION_TEXT.defaultMessage
};

export const DELETE_CONNECTION_TEXT = {
    id: 'oe.connection.only.delete.button',
    defaultMessage: 'Delete Connection only',
    description: 'Delete connection button'
};

export const DELETE_BOTH_TEXT = {
    id: 'oe.connections.delete.both.button',
    description: 'Delete connection button',
    defaultMessage: 'Delete Both'
};

export const PODIUM_LINK_TEXT = {
    ...PODIUM_LINK_ENABLED_TEXT,
    message: PODIUM_LINK_ENABLED_TEXT.defaultMessage
};
